<template>
  <AppHeader>Low Balance Customers</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Wallet</th>
            <th>Subs</th>
            <th>Group</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(customer, index) in data" :key="customer.id">
            <td>{{ index + 1 }}</td>
            <td><b><router-link :to="{name: 'ViewCustomer', params: {id: customer.id}}">{{ customer.name }} <small>(#{{ customer.id }})</small></router-link></b></td>
            <td align="center"><a @click="initiateCall(customer.phone)" class="px-2"><i class="ion-md-call"></i></a></td>
            <td>{{ toInr(customer.wallet_balance) }}</td>
            <td>{{ customer.subscriptions_count }}</td>
            <td>{{ customer.group.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'ReportLowBalance',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'idle',
      data: null,
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'reports/lowbalance', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.data = resp.data;
        else alert(resp.message);
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
